import { optionsGen } from "../helpers/api";
import { trim } from "lodash";
import "whatwg-fetch";

const isPatNumSearch = f => ["publication_number", "grant_number"].includes(f);

const toESWildcardClause = (f, v, extra) => {
  let val = trim(v, "'\"").toLowerCase();
  let clause = { wildcard: { [f]: `*${val}*` } };
  return extra ? { bool: { must: [clause, { match: extra }] } } : clause;
}

const toESPatentNumberClause = (f, v) => {
  // v in format of 6876979, 6876,979, US-6876979, US6876979, US6876979B2, US-RE48629-E1
  const [, country, number] = trim(v, "'\"")
    .replace(/\W/g, "")
    .replace(/[A-Z]\d?$/i, "") // Remove kind code suffix like B1 in US-8370264-B1 
    .match(/^(US|CN|JP|DE|EP|KR|WO|GB|CA|AU|FR|TW|ES|RU|AT|IN|SU|IT|BR|SE)?(\w+)/i);
  return {
    bool: {
      should: [
        // avoid leading wildcard, and search grant_number instead
        { wildcard: { "grant_number": `${number}*` } },
        // boost US patents in results if country code is not provided
        { prefix: { "publication_number": { value: `${country || "US"}-${number}`, boost: 4 } } },
      ]
    }
  };
}

export function toESQuickSearchDocQuery(v, fields, extraQuery) {
  const queries = fields.map(f => isPatNumSearch(f) ? toESPatentNumberClause(f, v) : toESWildcardClause(f, v, extraQuery))
  const query = queries.length === 1 ? queries[0] : { dis_max: { queries } }
  return {
    _source: { include: fields },
    query
  };
}

export function toESQuickSearchFieldQuery(v, fields, extraQuery) {
  // TODO: query should return list of matching values in these fields
  const queries = fields.map(f => isPatNumSearch(f) ? toESPatentNumberClause(f, v) : toESWildcardClause(f, v, extraQuery))
  const query = queries.length === 1 ? queries[0] : { dis_max: { queries } }
  let q = {
    _source: { include: fields },
    query,
    aggs: {}
  };
  fields.forEach(
    field =>
    (q.aggs[field] = {
      terms: {
        field: field,
        size: 10,
        shard_size: 10 * 10
      }
    })
  );
  return q;
}

export function getQuickSearchResult(searchType, esUrl, fields, value, extraQuery) {
  // searchType: doc or field, doc returns documents like cases, field returns unique matching field values
  // for field search type, only one field is allowed
  const apiCall = searchType === "field" ? toESQuickSearchFieldQuery : toESQuickSearchDocQuery;
  return fetch(esUrl, optionsGen("POST", apiCall(value, fields, extraQuery), false))
    .then(resp => resp.json())
    .then(json => {
      if (searchType === "doc") {
        return json.hits.hits.map(h => h._source);
      } else if (searchType === "field") {
        return json.aggregations[fields[0]].buckets.map(b => b.key).filter(v => v.includes(value));
      } else {
        return [];
      }
    });
}
